import { render, staticRenderFns } from "./FrrIntro.vue?vue&type=template&id=368b761a&scoped=true&"
import script from "./FrrIntro.vue?vue&type=script&lang=js&"
export * from "./FrrIntro.vue?vue&type=script&lang=js&"
import style0 from "./FrrIntro.sass?vue&type=style&index=0&id=368b761a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b761a",
  null
  
)

export default component.exports